import React from 'react';
import { TableHead, TableCell, Hidden } from '@material-ui/core';
import { useTranslations } from 'utils/useTranslations';
import { useStyles } from '../styles';

const PaymentTableHead = () => {
  const styles = useStyles();
  const intl = useTranslations();

  return (
    <TableHead>
      <TableCell className={styles.column}>{intl('shared.date')}</TableCell>
      <TableCell className={styles.column}>{intl('patient.accountNumber')}</TableCell>
      <TableCell className={styles.column}>{intl('patient.amount')}</TableCell>
      <TableCell className={styles.column}>{intl('patient.trsType')}</TableCell>
      <Hidden smDown>
        <TableCell className={styles.column}>{intl('patient.registered')}</TableCell>
      </Hidden>
      <TableCell className={styles.column} />
    </TableHead>
  );
};

export default PaymentTableHead;
